import delve from 'dlv'
import { evaluateOperator } from './evaluateOperator'
export function evaluateCondition ({ obj, currentValues }) {
  const normalizedCondition = Object.keys(obj.condition).reduce(
    (cond, path) => {
      // turns {foo: 'bar'} into {foo: ['bar']}
      const values = Array.isArray(obj.condition[path])
        ? obj.condition[path]
        : [obj.condition[path]]
      return {
        ...cond,
        [path]: values.map(value => {
          // turns 'foo' into {operator: '===', value: 'foo'}
          if (typeof value === 'object' && value.operator) {
            return value
          }
          return {
            operator: '===',
            value
          }
        })
      }
    },
    {}
  )
  const rule = obj.conditionMatch === 'all' ? 'every' : 'some'
  return Object.keys(normalizedCondition)[rule](path => {
    const conditions = normalizedCondition[path]
    const currentValue = delve(currentValues, path)
    return conditions[rule](evaluateOperator(currentValue))
  })
}
